import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

window.addEventListener('load', () => {
    handleSwiperInit();
});

window.addEventListener('resize', () => {
});

function handleSwiperInit() {
    const blocks = document.querySelectorAll('.applications-block');

    blocks.forEach((block) => {
        const container = block.querySelector('.swiper');
        if (!container) return;

        const prevBtn = block.querySelector('.arrow-help-prev');
        const nextBtn = block.querySelector('.arrow-help-next');

        const swiper = new Swiper(container, {
            modules: [Navigation],
            spaceBetween: 20,
            slidesPerView: 1,
            navigation: {
                nextEl: block.querySelector('.swiper-button-next'),
                prevEl: block.querySelector('.swiper-button-prev'),
            },
        });

        nextBtn.addEventListener('click', () => swiper.slideNext());
        prevBtn.addEventListener('click', () => swiper.slidePrev());
    });
}
